import { Component } from '@angular/core';
import { NavParams, ViewController, Events } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoRenewalInformationPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-renewal-information-popover',
  templateUrl: 'co-renewal-information-popover.html'
})
export class CoRenewalInformationPopoverComponent {
  private renewedItems: Array<any> = [];
  private failRenewals: Array<any> = [];
  private allrenews: Array<any>;
  constructor(public viewCtrl: ViewController, public navParams: NavParams, private events : Events, private timeout : TimeoutFunctionsProvider, private state : AppState) {
    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));
    this.renewedItems = this.navParams.get('renewals');
    this.failRenewals = this.navParams.get('failures');

    // for (let x=0; x<30; x++){ // TESTING DATA
    //   this.renewedItems.push({"id":"22771928","dueDate":"2019-12-26","numberOfRenewals":1,"outDate":"2019-11-27T15:04:54Z","bib":{"id":"1788927","title":"Broken","author":"Armstrong, Kelley.","isbns":["9780553588187"],"sources":[],"callNumbers":["Fiction "],"publishYear":2006,"typeCode":"a","typeName":"PRINT MATL"},"barcode":"0001479964", "status": true});
      // this.failRenewals.push({
      //   "id":"22771928","dueDate":"2019-12-26","numberOfRenewals":1,"outDate":"2019-11-27T15:04:54Z","bib":{"id":"1788927","title":"Broken","author":"Armstrong, Kelley.","isbns":["9780553588187"],"sources":[],"callNumbers":["Fiction "],"publishYear":2006,"typeCode":"a","typeName":"PRINT MATL"},"barcode":"0001479964","status":false
      // })
    // }

    // this.allrenews = this.renewedItems.concat(this.failRenewals);
    this.allrenews = this.failRenewals.concat(this.renewedItems);
  }

  close(){
    this.viewCtrl.dismiss().catch(err=>{});
  }



}



// WEBPACK FOOTER //
// ./src/components/co-renewal-information-popover/co-renewal-information-popover.ts